import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M20.25 0L9 11.25 3.75 6 0 9.75l9 9 15-15L20.25 0z" fill="#090" /></svg>;